export default __webpack_public_path__ + "static/media/info-fill.849a887d.svg";